import React, { useRef, useState, useEffect } from "react";
import UiButton, { UI_BUTTON_TYPE } from "../ui/UiButton";
import UiIcon from "../ui/UiIcon";
import { ICON } from "../../assets";
import "./Invoice.css";
import FSLoader from "../Loaders/FSLoader";

function UserInvoice({ isInvoiceVisible, toggleLeftDiv, pdfData }) {
  let frameId = "frame_commande_histo";
  const frameRef = useRef(null);
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (pdfData.url) {
      setLoading(true);
      const req = new XMLHttpRequest();
      req.open("GET", pdfData.url, true);
      req.responseType = "blob";
      req.onload = function () {
        if (req.status === 200) {
          const blob = new Blob([req.response], {
            type: "application/pdf",
          });
          const url = URL.createObjectURL(blob);
          setBlobUrl((prev) => {
            if (prev) URL.revokeObjectURL(prev);
            return url;
          });
        }
        setLoading(false);
      };
      req.onerror = () => {
        setLoading(false);
        console.error("Failed to fetch PDF document");
      };
      req.send();
    } else {
      setBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
    }

    return () => {
      setBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
    };
  }, [pdfData.url]);

  function renderInvoiceActionContent() {
    const onPrintFromIFrame = () => {
      const frame = frameRef.current;
      if (frame && frame.contentWindow) {
        try {
          frame.contentWindow.focus();
          frame.contentWindow.print();
        } catch (e) {
          console.error("Print error:", e);
          // Fallback if print is still blocked or unsupported
          window.open(blobUrl, "_blank");
        }
      } else {
        alert("Le document n'est pas prêt pour impression");
      }
    };

    const onDirectDownload = () => {
      if (!blobUrl) return;
      const fileName = (pdfData.documentName || "document_") + (pdfData.NUMCDC || "") + ".pdf";
      const a = document.createElement("a");
      a.setAttribute("download", fileName);
      a.setAttribute("href", blobUrl);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    return (
      <React.Fragment>
        <div className="action-buttons">
          <UiButton
            size="sm"
            buttonUiType={[UI_BUTTON_TYPE.ONLY_BORDER]}
            disabled={!blobUrl || loading}
            content={
              <React.Fragment>
                <div className="invoice-container__action">
                  <UiIcon icon={ICON.printerIcon} alt="printer" size="md" />
                  <span>Imprimer</span>
                </div>
              </React.Fragment>
            }
            onClick={onPrintFromIFrame}
          />
          <UiButton
            size="sm"
            disabled={!blobUrl || loading}
            buttonUiType={[UI_BUTTON_TYPE.ONLY_BORDER]}
            content={
              <React.Fragment>
                <div className="invoice-container__action">
                  <UiIcon icon={ICON.downloadIcon} alt="download" size="md" />
                  <span>Télécharger</span>
                </div>
              </React.Fragment>
            }
            onClick={onDirectDownload}
          />
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div
        className={`invoice-container ${!isInvoiceVisible ? "element-hidden-display" : ""
          }`}
      >
        <div className="invoice-container__actions">
          {renderInvoiceActionContent()}
          <div className="invoice-container__close">
            <UiIcon
              icon={ICON.closeCrossIcon}
              onClick={toggleLeftDiv}
              size="sm"
            />
          </div>
        </div>
        <div className="invoice-container__content">
          {loading ? (
            <FSLoader />
          ) : blobUrl ? (
            <iframe
              ref={frameRef}
              title="frame"
              id={frameId}
              src={`${blobUrl}#toolbar=0`}
              style={{ height: "80vh", width: "100%" }}
            />
          ) : (
            <span>Aucun document sélectionné</span>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default UserInvoice;
